import React from 'react';
import {h, Component} from 'preact'
import MediaStreamRecorder from "msr";
import classNames  from "classnames";
import {
    FaStopCircle,
    FaMicrophone,
    FaPlayCircle,
    FaPauseCircle
} from "react-icons/fa";

export default class AudioMessageField extends Component {
    state = {
        stream: null,
        mediaRecorder: null,
        isRecording: false,
        isPaused: false,
    };

    constructor() {
        super(...arguments);
        this.toggleRecord = this.toggleRecord.bind(this);
        this.togglePause = this.togglePause.bind(this);
    }

    startRecording() {
        const mediaConstraints = {
            audio: true, // don't forget audio!
            video: false,
        };

        navigator.getUserMedia(
            mediaConstraints,
            (stream) => {
                const mediaStreamRecorder = new MediaStreamRecorder(stream);
                mediaStreamRecorder.mimeType = "audio/wav";
                mediaStreamRecorder.ondataavailable = (blob) => {
                    this.props.onRecorded(blob);
                };
                mediaStreamRecorder.start(3600 * 1e3);

                this.setState({
                    mediaRecorder: mediaStreamRecorder,
                    stream: stream,
                    isRecording: true
                });
            },
            (err) => {
                console.error(err);
                alert("You have to grant privileges to access your microphone to send audio messages.");
            },
        );
    }

    stopRecording() {
        this.state.mediaRecorder.resume();
        this.state.mediaRecorder.stop();
        this.state.stream.getAudioTracks().forEach(function(track) {
            track.stop();
        });

        this.setState({
            stream: null,
            isRecording: false,
            mediaRecorder: null
        })
    }

    toggleRecord() {
        if (this.state.isRecording) {
            this.stopRecording();
        } else {
            this.startRecording();
        }
    }

    togglePause() {
        this.state.isPaused ? this.state.mediaRecorder.resume() : this.state.mediaRecorder.pause();
        this.setState(({ isPaused }) => ({isPaused: !isPaused}));
    }

    render() {
        const { disabled } = this.props;
        const { isRecording, isPaused } = this.state;

        return (
            <div className={classNames({
                "is-recording": isRecording,
                "is-paused": isPaused
            })}>
                <button type="button" className="audio-btn no-shadow border-0" onClick={disabled ? null : this.toggleRecord} disabled={disabled}>
                    {isRecording ?
                        <FaStopCircle
                            className={"icon-size-20 recording-stop-icon mr-1"}
                        />
                        :
                        <FaMicrophone
                            className={"icon-size-20 color-icon mr-1"}
                        />
                    }
                </button>

                {isRecording ? (
                    <button type="button" className="audio-btn no-shadow border-0" onClick={disabled ? null : this.togglePause} disabled={disabled}>
                        {isPaused ?
                            <FaPlayCircle
                                className={"icon-size-20 recording-play-icon mr-1"}
                            />
                            :
                            <FaPauseCircle
                                className={"icon-size-20 recording-pause-icon mr-1"}
                            />
                        }
                    </button>
                ) : null}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/app/widget/audio/AudioMessageField.js